import { render, staticRenderFns } from "./FaceAvatarStandard.vue?vue&type=template&id=5ff2de61"
import script from "./FaceAvatarStandard.vue?vue&type=script&lang=js"
export * from "./FaceAvatarStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports